import joi, { object, ObjectSchema } from 'joi';
import { useForm } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';
import { JoiValidationOptionsConstant, requiredTemplateString } from '@vivli/shared/infrastructure/constants';
import { INotification } from '@vivli/shared/features/notification/infrastructure/interface';

const formSchema: ObjectSchema<INotification> = joi
    .object({
        //the form default is null and a cleared input is '', both of which joi reports as
        //number.base rather than any.required - remap it so the popover reads like the other fields
        notificationFrequency: joi
            .number()
            .required()
            .integer()
            .min(1)
            .label('Frequency (Days)')
            .messages({ 'number.base': requiredTemplateString }),
        notificationText: joi.string().required().label('Notification Text'),
        active: joi.boolean().optional().label('Active'),
        startDate: joi.date().iso().required().label('Start Date'),
        endDate: joi
            .date()
            .iso()
            .required()
            .label('End Date/ Next Checkin')
            .custom((value, helpers) => {
                if (value < joi.ref('startDate')) {
                    return helpers.message({ custom: 'End date must be greater than or equal to start date' });
                }
                return value;
            })
    })
    .options(JoiValidationOptionsConstant);

//exported so callers starting a brand new notification can reset back to these. Resetting
//with no argument would restore whichever notification was last loaded, carrying its id.
export const notificationFormDefaultValues: INotification = {
    notificationText: '',
    active: false,
    startDate: '',
    endDate: '',
    notificationFrequency: null
};

export function useNotificationForm(
    notification: INotification = notificationFormDefaultValues,
    mode: 'onBlur' | 'onChange' | 'onTouched' | 'all' = 'onChange'
) {
    return useForm({
        mode,
        resolver: joiResolver(formSchema),
        defaultValues: notification,
        reValidateMode: 'onChange'
    });
}
